// extracted by mini-css-extract-plugin
export default {"image":"Background_image__d3PBx"};